module.exports = __webpack_public_path__ + "img/up-arrow.486d082.png";